import React from "react";
import ajax from "./../../lib/ajax.js";
import context from "../../lib/context.js";
import util from "./../../lib/util.js";
import { FormControl, ControlLabel, Button, Alert } from "react-bootstrap";
import DatePicker from "react-bootstrap-date-picker";
import { browserHistory } from "react-router";
import RequestActivityList from "./request-activity-list.jsx";
import CodeList from "./../shared/codelist.jsx";
import Navigation from "./../shared/navigation.jsx";
import StringAutoComplete from "./../shared/string-autocomplete";

export default class ApplicantEntry extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            applicant: null,
            errors: [],
            successMessage: '',
            resources: {}
        }

        this.role = context.getRouteParam(this, "role");
        this.loadViewModel = this.loadViewModel.bind(this);
        this.validate = this.validate.bind(this);
        this.getButtons = this.getButtons.bind(this);
        this.onSubmitClick = this.onSubmitClick.bind(this);
        this.onCancelClick = this.onCancelClick.bind(this);
        this.getFormattedDate = this.getFormattedDate.bind(this);
        this.onApplicantChange = this.onApplicantChange.bind(this);
        this.onFormControlChange = this.onFormControlChange.bind(this);
        this.onValueChange = this.onValueChange.bind(this);
        this.onYesNoClick = this.onYesNoClick.bind(this);
        this.onInterviewDateChange = this.onInterviewDateChange.bind(this);
        this.onResumeRecordedDateChange = this.onResumeRecordedDateChange.bind(this);
        this.onSearchDateChange = this.onSearchDateChange.bind(this);
        this.getLinks = this.getLinks.bind(this);
        this.onTestingRequirementsChange = this.onTestingRequirementsChange.bind(this);
        this.loadResources = this.loadResources.bind(this);
    }

    componentDidMount() {
        this.loadViewModel();
        this.loadResources();
    }

    loadResources() {
        const self = this;

        ajax.vm()
            .get(`applicant-entry-resources`)
            .then(function (res) {
                self.setState({ resources: res.data });
            })
            .catch(function (err) {
                let data = err.response.data;
                if (data.exceptionMessage && data.exceptionMessage.toLowerCase().indexOf("unauthorize") > -1) {
                    browserHistory.push(context.routeUrl(`home`));
                }
                else
                    context.message({
                        show: true,
                        type: "error",
                        message: data.exceptionMessage || data.message,
                        buttons: "close"
                    });
            });
    }

    loadViewModel() {
        const self = this;

        ajax.vm()
            .get(`get-applicant/${this.props.routeParams.applicantId}/${this.props.routeParams.requestId}/${this.role}`)
            .then(function (res) {
                if (self.props.routeParams.applicantId == 0)
                    res.data.searchDate = null;

                self.setState({
                    applicant: res.data 
                });

                context.message({ show: false });
            })
            .catch(function (err) {
                let data = err.response.data;
                if (data.exceptionMessage && data.exceptionMessage.toLowerCase().indexOf("unauthorize") > -1)
                    browserHistory.push(context.routeUrl(`home`));
                else
                    context.message({
                        show: true,
                        type: "error",
                        message: data.exceptionMessage || data.message,
                        buttons: "close"
                    });
            });
    }

    onApplicantChange(values) {
        var applicant = this.state.applicant;

        for (var i = 0; i < values.length; i++) {
            var key = values[i].key;
            var value = values[i].value;
            applicant[key] = value;
        }

        this.setState({
            applicant: applicant,
            successMessage: ''
        });
    }

    onInterviewDateChange(value) {
        this.onApplicantChange([{ key: 'interviewDate', value: value }]);
    }
        
    onResumeRecordedDateChange(value) {
        this.onApplicantChange([{ key: 'resumeRecordedDate', value: value }]);
    }

    onSearchDateChange(value) {
        this.onApplicantChange([{ key: 'searchDate', value: value }]);
    }

    onFormControlChange(event) {
        this.onApplicantChange([{ key: event.target.id, value: event.target.value }]);
    }

    onValueChange(value, description, key) {
        this.onApplicantChange([{ key: key, value: value }]);
    }

    onYesNoClick(event) {
        var value = true;
        if (event.target.id == event.target.name + 'No') {
            value = false;
        }

        this.onApplicantChange([{ key: event.target.name, value: value }]);
    }

    onTestingRequirementsChange(items) {
        this.onApplicantChange([{ key: "testingRequirements", value: JSON.stringify(items) }]);
    }

    validate() {
        var applicant = this.state.applicant;
        let msg = [];

        if (applicant.fullName == null || applicant.fullName == '') {
            msg.push({field: 'fullName', error: this.state.resources.nameIsRequired});
        }

        var searchDate = this.getFormattedDate("searchDate");
        if (searchDate == '' || searchDate == null) {
            msg.push({field: 'searchDate', error: this.state.resources.searchDateIsRequired});
        }
        else if (util.isMMDDYYYY(searchDate, false) == false) {
            msg.push({field: 'searchDate', error: this.state.resources.searchDateIsInvalidFormat});
        }

        var interviewDate = this.getFormattedDate('interviewDate');
        if (interviewDate != '')
            if (util.isMMDDYYYY(interviewDate, false) == false) {
                msg.push({field: 'interviewDate', error: this.state.resources.interviewDateIsInvalidFormat});
            }

        var resumeRecordedDate = this.getFormattedDate('resumeRecordedDate');
        if (resumeRecordedDate != '')
            if (util.isMMDDYYYY(resumeRecordedDate, false) == false) {
                msg.push({field: 'resumeRecordedDate', error: this.state.resources.dateResumeRecordedIsInvalidFormat});
            }

        return msg;
    }

    getFormattedDate(id) {
        return $('#' + id).next().val().trim(); 
    }

    getButtons() {
        var buttons = [];

        buttons.push(<Button id="submit" onClick={this.onSubmitClick} className="btn-info">{this.state.resources.submit}</Button>);
        buttons.push(<Button id="cancel" onClick={this.onCancelClick} className="btn-info" >{this.state.resources.cancel}</Button>);

        return buttons;                        
    }

    onSubmitClick(event) {
        var errors = this.validate();

        if (errors.length > 0) {
            this.setState({ 
                errors: errors,
                successMessage: ''
            });

            return false;
        }
        else {
            context.message({
                show: true,
                type: "loading",
                message: this.state.resources.savingPleaseWait
            });            
            
            this.setState({
                errors: [],
                successMessage: ''
            });

            const self = this;

            ajax.api()
            .post("save-applicant", this.state.applicant)
            .then(function (res) {
                var applicantID = self.state.applicant.applicantID;

                self.setState({
                    applicant: res.data,
                    successMessage: self.state.resources.applicantSavedSuccessfully
                });

                if (applicantID == 0) {
                    browserHistory.push(context.routeUrl(`${self.role}/applicant-entry/${res.data.requestID}/${res.data.applicantID}`));
                }

                context.message({ show: false });
            })
            .catch(function (err) {
                console.log(err);
                let data = err.response.data;
                if (data.message.toLowerCase().indexOf("unauthorize") > -1)
                    window.location = context.root() + `/../AccessDenied.aspx`;
                else
                    context.message({
                        show: true,
                        type: "error",
                        message: data.exceptionMessage || data.message,
                        buttons: "close"
                    });
            });
        }
    }
        
    onCancelClick() {
        browserHistory.push(context.routeUrl(`${this.role}/applicant-log-main/${this.props.routeParams.requestId}`));
    }

    getLinks() {
        var links = [
            { name: this.state.resources.home, link: context.routeUrl('home'), active: true },
            { name: this.state.resources.positionRequisition, link: context.routeUrl(`${this.role}/prf-main`), active: true },
            { name: 'Req. ' + this.props.routeParams.requestId + ' (' + this.state.applicant.requestPositionTitle + ')', link: context.routeUrl(`${this.role}/request-entry/${this.props.routeParams.requestId}`), active: true },
            { name: this.state.resources.applicantLog, link: context.routeUrl(`${this.role}/applicant-log-main/${this.props.routeParams.requestId}`), active: true }
        ];

        if (this.state.applicant.applicantID == 0) {
            links.push({ name: this.state.resources.newApplicant, link: '#', active: false })
        }
        else {
            links.push({ name: this.state.resources.applicant + ' (' + this.state.applicant.fullName + ')', link: '#', active: false })
        }
        
        return links;        
    }

    render() {
        if (this.state.applicant == null) {
            return <div className="container"></div>
        }

        var errors = [];
        this.state.errors.map(function (item, i) {
            if (item.error.length > 0) {
                errors.push(<li key={item.field}>{item.error}</li>);
            }
        });

        return (
            <div style={{ "backgroundColor" : "rgb(239, 239, 239)" }}>
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <Navigation links={this.getLinks()} />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-8 ap-white-background">
                            <div className="row hidden-sm hidden-xs">
                                <div className="col-md-12">
                                    <ControlLabel>
                                        {this.state.resources.applicantEntryHeaderMessage}
                                    </ControlLabel>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-offset-10 col-md-2 pull-right">
                                    <ControlLabel className="pull-right"><span className="required">* {this.state.resources.required}</span></ControlLabel>
                                </div>  
                            </div>
                            <div className="row">
                                <div className="col-md-6">
                                    <ControlLabel className="ap-report-control-label">{this.state.resources.name}: <span className="required">*</span></ControlLabel>
                                    <FormControl 
                                        id="fullName"
                                        type="text" 
                                        value={this.state.applicant.fullName}
                                        className={this.state.errors.filter(x => x.field == 'fullName').length > 0 ? 'ap-report-control-error' : ''}
                                        onChange={this.onFormControlChange}>
                                    </FormControl>
                                </div>
                                <div className="col-md-6">
                                    <ControlLabel className="ap-report-control-label">{this.state.resources.interviewDate}:</ControlLabel>
                                    <DatePicker 
                                        id="interviewDate"
                                        placeholder="MM/DD/YYYY" 
                                        value={this.state.applicant.interviewDate}
                                        onChange={this.onInterviewDateChange} 
                                        className={this.state.errors.filter(x => x.field == 'interviewDate').length > 0 ? 'ap-report-control-error' : ''} />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-6">
                                    <ControlLabel className="ap-report-control-label">{this.state.resources.dateResumeRecorded}:</ControlLabel>
                                    <DatePicker 
                                        id="resumeRecordedDate"
                                        placeholder="MM/DD/YYYY" 
                                        value={this.state.applicant.resumeRecordedDate}
                                        onChange={this.onResumeRecordedDateChange} 
                                        className={this.state.errors.filter(x => x.field == 'resumeRecordedDate').length > 0 ? 'ap-report-control-error' : ''} />
                                </div>
                                <div className="col-md-6">
                                    <ControlLabel className="ap-report-control-label">{this.state.resources.searchDate}: <span className="required">*</span></ControlLabel>
                                    <DatePicker 
                                        id="searchDate"
                                        placeholder="MM/DD/YYYY" 
                                        value={this.state.applicant.searchDate}
                                        onChange={this.onSearchDateChange} 
                                        className={this.state.errors.filter(x => x.field == 'searchDate').length > 0 ? 'ap-report-control-error' : ''} />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-6">
                                    <ControlLabel className="ap-report-control-label">{this.state.resources.gender}:</ControlLabel>
                                    <CodeList 
                                        id="sex" 
                                        value={this.state.applicant.sex} 
                                        onChange={this.onValueChange} 
                                        category="EEOC_GENDER"
                                        allText={this.state.resources.selectGender}
                                        className={this.state.errors.filter(x => x.field == 'sex').length > 0 ? 'ap-report-control-error' : ''} />
                                </div>
                                <div className="col-md-6">
                                    <ControlLabel className="ap-report-control-label">{this.state.resources.ethnicity}:</ControlLabel>
                                    <CodeList 
                                        id="ethnicity" 
                                        value={this.state.applicant.ethnicity} 
                                        onChange={this.onValueChange} 
                                        category="EEOC_ETHNICITY"
                                        allText={this.state.resources.selectEthnicity}
                                        className={this.state.errors.filter(x => x.field == 'ethnicity').length > 0 ? 'ap-report-control-error' : ''} />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-6">
                                    <ControlLabel className="ap-report-control-label">{this.state.resources.internetApplicant}:</ControlLabel>
                                    <div className="row">
                                        <div className="col-md-4">
                                            <Button 
                                                id="internetApplicantYes"
                                                name="internetApplicant"
                                                className={"btn-info ap-fullsize " + (this.state.applicant.internetApplicant == true ? "btn-selected" : "")}
                                                onClick={this.onYesNoClick}>
                                                {this.state.resources.yes}
                                            </Button>
                                        </div>
                                        <div className="col-md-4">
                                            <Button 
                                                id="internetApplicantNo"
                                                name="internetApplicant"
                                                className={"btn-info ap-fullsize " + (this.state.applicant.internetApplicant == false ? "btn-selected" : "")}
                                                onClick={this.onYesNoClick}>
                                                {this.state.resources.no}
                                            </Button>
                                        </div>
                                    </div>                       
                                </div>
                                <div className="col-md-6">
                                    <ControlLabel className="ap-report-control-label">{this.state.resources.specificSource}: <span className="ap-control-sub-label"> - ({this.state.resources.specificSourceSample})</span></ControlLabel>
                                    <CodeList 
                                        id="specificSource" 
                                        value={this.state.applicant.specificSource} 
                                        onChange={this.onValueChange} 
                                        category="PEO_RECRUITING_SOURCE"
                                        allText={this.state.resources.selectSpecificSource}
                                        className={this.state.errors.filter(x => x.field == 'specificSource').length > 0 ? 'ap-report-control-error' : ''} />                 
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-6">
                                    <ControlLabel className="ap-report-control-label">{this.state.resources.disability}:</ControlLabel>
                                    <div className="row">
                                        <div className="col-md-4">
                                            <Button 
                                                id="disabilityYes"
                                                name="disability"
                                                className={"btn-info ap-fullsize " + (this.state.applicant.disability == true ? "btn-selected" : "")}
                                                onClick={this.onYesNoClick}>
                                                {this.state.resources.yes}
                                            </Button>
                                        </div>
                                        <div className="col-md-4">
                                            <Button 
                                                id="disabilityNo"
                                                name="disability"
                                                className={"btn-info ap-fullsize " + (this.state.applicant.disability == false ? "btn-selected" : "")}
                                                onClick={this.onYesNoClick}>
                                                {this.state.resources.no}
                                            </Button>
                                        </div>
                                    </div>                       
                                </div>
                                <div className="col-md-6">
                                    <ControlLabel className="ap-report-control-label">{this.state.resources.veteran}:</ControlLabel>
                                    <div className="row">
                                        <div className="col-md-4">
                                            <Button 
                                                id="veteranYes"
                                                name="veteran"
                                                className={"btn-info ap-fullsize " + (this.state.applicant.veteran == true ? "btn-selected" : "")}
                                                onClick={this.onYesNoClick}>
                                                {this.state.resources.yes}
                                            </Button>
                                        </div>
                                        <div className="col-md-4">
                                            <Button 
                                                id="veteranNo"
                                                name="veteran"
                                                className={"btn-info ap-fullsize " + (this.state.applicant.veteran == false ? "btn-selected" : "")}
                                                onClick={this.onYesNoClick}>
                                                {this.state.resources.no}
                                            </Button>
                                        </div>
                                    </div>               
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-6">
                                    <ControlLabel className="ap-report-control-label">{this.state.resources.hired}:</ControlLabel>
                                    <div className="row">
                                        <div className="col-md-4">
                                            <Button 
                                                id="hiredYes"
                                                name="hired"
                                                className={"btn-info ap-fullsize " + (this.state.applicant.hired == true ? "btn-selected" : "")}
                                                onClick={this.onYesNoClick}>
                                                {this.state.resources.yes}
                                            </Button>
                                        </div>
                                        <div className="col-md-4">
                                            <Button 
                                                id="hiredNo"
                                                name="hired"
                                                className={"btn-info ap-fullsize " + (this.state.applicant.hired == false ? "btn-selected" : "")}
                                                onClick={this.onYesNoClick}>
                                                {this.state.resources.no}
                                            </Button>
                                        </div>
                                    </div>                        
                                </div>
                            </div>
                            <div className={"row " + (this.state.applicant.hired == true ? "ap-hidden" : "")}>
                                <div className="col-md-12">
                                    <ControlLabel className="ap-report-control-label">{this.state.resources.hiredNotes}:</ControlLabel>
                                    <FormControl 
                                        id="hiredNotes"
                                        componentClass="textarea"
                                        rows="5"
                                        value={this.state.applicant.hiredNotes}
                                        onChange={this.onFormControlChange}>
                                    </FormControl>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-6">
                                    <ControlLabel className="ap-report-control-label">{this.state.resources.testingRequirementsSkillsAssessmentForPosition}</ControlLabel>
                                    <StringAutoComplete
                                        id="testingRequirements" 
                                        url="get-skills-by-prefix"
                                        value=""
                                        data={this.state.applicant.testingRequirements == "" ? [] : JSON.parse(this.state.applicant.testingRequirements)}
                                        rows={10}
                                        valueFields={[{'field':'description','header':'Description'},
                                                    {'field':'code','header':'Code'}]}
                                        valueField="description"
                                        descriptionField="description"
                                        onMultipleSelect={this.onTestingRequirementsChange} 
                                        maxLength={100} 
                                        capitalized={false}
                                        multiple={true} /> 
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-6">
                                    <ControlLabel className="ap-report-control-label">{this.state.resources.willYouBeAdministeringTests}</ControlLabel>
                                    <div className="row">
                                        <div className="col-md-4">
                                            <Button 
                                                id="administeringTRYes"
                                                name="administeringTR"
                                                className={"btn-info ap-fullsize " + (this.state.applicant.administeringTR == true ? "btn-selected" : "")}
                                                onClick={this.onYesNoClick}>
                                                {this.state.resources.yes}
                                            </Button>
                                        </div>
                                        <div className="col-md-4">
                                            <Button 
                                                id="administeringTRNo"
                                                name="administeringTR"
                                                className={"btn-info ap-fullsize " + (this.state.applicant.administeringTR == false ? "btn-selected" : "")}
                                                onClick={this.onYesNoClick}>
                                                {this.state.resources.no}
                                            </Button>
                                        </div>
                                    </div>                       
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12">
                                    <ControlLabel className="ap-report-control-label">{this.state.resources.candidateNotes}:</ControlLabel>
                                    <FormControl 
                                        id="notes"
                                        componentClass="textarea"
                                        rows="5"
                                        value={this.state.applicant.notes}
                                        onChange={this.onFormControlChange}>
                                    </FormControl>
                                </div>
                            </div>
                            <hr className="ap-hr-normal" style={{ "marginTop" : "10px", "marginBottom" : "10px" }}  />
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="ap-button-container">
                                        {this.getButtons()}
                                    </div>
                                </div>
                            </div>
                            <div className={"row " + (this.state.errors.length > 0 ? "" : "ap-hidden")} style={{ "marginTop" : "10px" }}>
                                <div className="col-md-12 col-lg-12">
                                    <Alert bsStyle="danger">
                                        <ul>
                                            {errors}
                                        </ul>
                                    </Alert>
                                </div>
                            </div>
                            <div className={"row " + (this.state.successMessage.length > 0 ? "" : "ap-hidden")} style={{ "marginTop" : "10px" }}>
                                <div className="col-md-12 col-lg-12">
                                    <Alert bsStyle="success">
                                        <ControlLabel>{this.state.successMessage}</ControlLabel>
                                    </Alert>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <RequestActivityList data={this.state.applicant.requestActivities} />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}